import { Box, Card, CardContent, CircularProgress, ClickAwayListener, List, ListItem, ListItemText, makeStyles, Paper, Popover, Popper, TextField, Typography } from '@material-ui/core';
import { SearchOutlined } from '@material-ui/icons';
import { debounce, isEmpty } from 'lodash';
import { useCallback, useContext, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { anonForwardGeocode } from 'services/anon.service';
import locationsService from 'services/locations.service';
import { filterNonNull } from 'util/format';
import { toasterror } from 'util/toasterror';
import { useTrackEvent } from 'util/trackEvent';

const AUTOCOMPLETE_START_LENGTH = 3

const useStyles = makeStyles((theme) => {
  return {
    places: {
      paddingBottom: theme.spacing(2)
    },
    paper: {

      maxHeight: '25vh',
      overflowY: 'scroll',
    },
    tooltip: {
      marginBottom: theme.spacing(3),
      display: 'block',
      lineHeight: "1.25",
      textAlign: "center",
    }
  }
})
const LocationAutocomplete = ({
  sessionToken,
  onSelectAddress = () => { },
  centerLocation
}) => {
  const classes = useStyles()
  const [inputValue, setInputValue] = useState('');
  const [anchorEl, setAnchorEl] = useState();


  const [addressOptions, setAddressOptions] = useState([]);

  const open = Boolean(anchorEl);
  const id = open ? "search-popover" : undefined;

  const trackEvent = useTrackEvent()
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (target) => {
    // trackEvent('Location Autocomplete - search clicked', {})
    setAnchorEl(target);

  };

  const [addressLoading, setAddressLoading] = useState(false);

  useEffect(
    () => {
      console.log('LocationAutocomplete.jsx (58)', centerLocation)
    }, [centerLocation]
  );
  const fetchAC = useCallback(
    debounce(async (params, callback) => {
      trackEvent('Location Autocomplete - search', { query: params?.query })
      try {
        let result = null
        if (sessionToken) {
          result = await anonForwardGeocode(params?.query, params?.latitude, params?.longitude, sessionToken)
        } else {
          result = await locationsService.forwardGeocode(params?.query, params?.latitude, params?.longitude)
        }
        callback(result?.list);
      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details, {error})
        callback(null)
      } finally {
        setAddressLoading(false)
      }

    }, 3000),
    []
  );

  const onChangeSearch = useCallback(
    async (value) => {
      setAddressLoading(true)
      if (isEmpty(value) || isEmpty(centerLocation) || value?.length < AUTOCOMPLETE_START_LENGTH) {
        return
      } 
      const params = filterNonNull({
        query: value,
        latitude: centerLocation?.lat||centerLocation?.latitude,
        longitude: centerLocation?.lng || centerLocation?.long ||centerLocation?.longitude,
      })
      
      fetchAC(params, (results) => {
        setAddressOptions(results ?? []);
      })
    },
    [centerLocation, fetchAC],
  );


  return (
    <Box width={1} className={classes.places}>
      <Typography className={classes.tooltip} variant="caption">Enter your address in the box below or drag the map to your exact location.</Typography>
      <TextField
        value={inputValue}
        fullWidth
        label="Filter address"
        onChange={(event) => {
          handleClick(event?.target?.parentElement)
          setInputValue(event.target.value);
          onChangeSearch(event.target.value);
        }}
        InputProps={{
          endAdornment: addressLoading ? <CircularProgress size={20} /> : <SearchOutlined />
        }}
        inputProps={{
          autocomplete: 'new-password',
          form: {
            autocomplete: 'off',
          },
        }}
        variant="outlined"
        InputLabelProps={{
          shrink: true
        }}
        id={id}
        onClick={(evt)=>handleClick(evt.currentTarget)}
        size="small"
      />
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        placement="bottom"
        transition
        style={{
          zIndex: 9999,
          width: anchorEl ? anchorEl.clientWidth : null,
        }}
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'viewport',
          },
        }}
        disableAutoFocus={true}
        disableEnforceFocus={true}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Card elevation={3}>
            <CardContent className={classes.paper}>
              {!isEmpty(addressOptions) ? (
                <List
                  component="nav"
                  aria-label="secondary mailbox folder"

                >
                  {addressOptions?.map((address, index) => {
                    return (
                      <ListItem
                        key={index}
                        button
                        onClick={() => {
                          trackEvent('Location Autocomplete - selected address', { address: address })
                          onSelectAddress(address)
                          handleClose()
                        }}
                      >
                        <ListItemText primary={address?.address} />
                      </ListItem>
                    );
                  })}
                </List>
              ) : (
                <List
                  component="nav"
                >
                  <ListItem button disabled>
                    <ListItemText secondary="No match" />
                  </ListItem>
                </List>
              )}
            </CardContent>
          </Card>
        </ClickAwayListener>
      </Popper>
    </Box>
  )
}

export { LocationAutocomplete };
